module.exports = __webpack_public_path__ + "7a23a0d7708a30ab82e68d847dda99eb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gb-nir.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gb-nir.svg
// module chunks = 0